<footer class="bg-gradient-to-t from-[#0B2B20] to-[#195D46] pt-[40px] pb-[20px] px-6 xl:px-[80px]">
  <div class="flex flex-col gap-[20px] items-center">

  <div class="flex flex-col md:flex-row justify-between w-full gap-[20px] md:gap-[40px] items-center">
   <!-- Logo Section -->
   <div class="flex flex-col w-full md:w-3/4 justify-between gap-[20px] items-start">
      <nav class="flex flex-row flex-wrap gap-x-[12px] gap-y-[8px] w-full justify-start md:justify-between items-center" dir="rtl">
        <a
          [routerLink]="['/prosecution/aboutProsecution']"
          class="group text-[#FDCB39] font-bold flex flex-row-reverse items-center gap-[10px] text-[32px] text-white transition-colors duration-200 hover:text-[#FFBE11]"
          style="font-family: 'Lyon Arabic Display', sans-serif;"
        >
            <span class="underline-offset-4 group-hover:underline">
            {{ 'Home.info' | translate }}
          </span>
        </a>
        <span class="text-[32px] text-[#FDCB39]">|</span>
        <a
          [routerLink]="['/news/allNews']"
           class="group text-[#FDCB39] font-bold flex flex-row-reverse items-center gap-[10px] text-[32px] text-white transition-colors duration-200 hover:text-[#FFBE11]"
          style="font-family: 'Lyon Arabic Display', sans-serif;"
        >
            <span class="underline-offset-4 group-hover:underline">
            {{ 'Home.NewsAndEvents' | translate }}
          </span>
        </a>
        <span class="text-[32px] text-[#FDCB39]">|</span>
        <a
          [routerLink]="['/services/allServices']"
           class="group text-[#FDCB39] font-bold flex flex-row-reverse items-center gap-[10px] text-[32px] text-white transition-colors duration-200 hover:text-[#FFBE11]"
          style="font-family: 'Lyon Arabic Display', sans-serif;"
        >
            <span class="underline-offset-4 group-hover:underline">
            {{ 'Home.Services' | translate }}
          </span>
        </a>
        <span class="text-[32px] text-[#FDCB39]">|</span>
        <a
          [routerLink]="['/prosecution/President']"
           class="group text-[#FDCB39] font-bold flex flex-row-reverse items-center gap-[10px] text-[32px] text-white transition-colors duration-200 hover:text-[#FFBE11]"
          style="font-family: 'Lyon Arabic Display', sans-serif;"
        >
            <span class="underline-offset-4 group-hover:underline">
            {{ 'Home.HeadOfAdministrative' | translate }}
          </span>
        </a>
      </nav>
    </div>
  <div class="flex flex-col w-full md:w-1/4 justify-between gap-[20px] items-center md:items-end">
   
    <!-- Logo -->
    <div class="h-[118px] w-[121px]  relative">
      <img
        src="/images/Logo.png"
        [alt]="'Header.LogoAlt' | translate"
        class="w-full h-full object-contain"
      />
    </div>

    <!-- Social Media Icons -->
    <div class="flex gap-[8px] items-center">
      @for (item of socialItems(); track item.platform) {
        <a
          [href]="item.url"
          target="_blank"
          rel="noopener noreferrer"
          class="w-[25px] h-[25px] flex items-center justify-center text-white hover:text-[#FFBE11] transition-colors duration-200"
          [attr.aria-label]="item.platform"
        >
          <!-- <i [class]="'pi pi-' + getIconClass(item.platform) + ' text-[16px]'"></i> -->
          @switch (item.platform.toLowerCase()) {
            @case ('facebook') {
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.2085 14.815L5.2085 10.7641L8.90168 10.7641L8.90168 2.0835L19.7918 2.0835V6.71313L13.8259 6.71313V10.7641L18.7502 10.7641L17.1877 14.815L13.8259 14.815L13.8259 22.9168L8.90168 22.9168L8.90168 14.815L5.2085 14.815Z" fill="#B9A260"/>
                </svg>
                
            }
            @case ('instagram') {
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.34375 3.125C2.34375 2.69353 2.69353 2.34375 3.125 2.34375L21.875 2.34375C22.3065 2.34375 22.6562 2.69353 22.6562 3.125L22.6562 21.875C22.6562 22.3065 22.3065 22.6562 21.875 22.6562L3.125 22.6562C2.69353 22.6562 2.34375 22.3065 2.34375 21.875L2.34375 3.125ZM17.1875 12.5C17.1875 15.0888 15.0888 17.1875 12.5 17.1875C9.91116 17.1875 7.8125 15.0888 7.8125 12.5C7.8125 9.91117 9.91116 7.8125 12.5 7.8125C15.0888 7.8125 17.1875 9.91117 17.1875 12.5ZM17.1863 7.8125L19.279 7.8125V5.72917H17.1863V7.8125Z" fill="#B9A260"/>
                </svg>
                
            }
            @case ('linkedin') {
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.771 4.427C6.771 5.72142 5.72166 6.77075 4.42725 6.77075C3.13283 6.77075 2.0835 5.72142 2.0835 4.427C2.0835 3.13258 3.13283 2.08325 4.42725 2.08325C5.72166 2.08325 6.771 3.13258 6.771 4.427Z" fill="#B9A260"/>
                <path d="M2.0835 9.89575L2.0835 22.9166H6.771L6.771 9.89575H2.0835Z" fill="#B9A260"/>
                <path d="M9.896 9.89575L14.5836 9.89575V11.6395C15.3925 10.5761 16.6303 9.896 18.0176 9.896C20.4547 9.896 22.9169 11.9947 22.9169 14.5835L22.9155 22.9166H18.2293V16.4064C18.2293 15.3996 17.4132 14.5835 16.4064 14.5835C15.3997 14.5835 14.5836 15.3996 14.5836 16.4064L14.5836 22.9166H9.896L9.896 9.89575Z" fill="#B9A260"/>
                </svg>
                
            }
            @case ('x') {
              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="#B9A260"/>
              </svg>
            }
            @case ('twitter') {
              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="#B9A260"/>
              </svg>
            }
            @case ('telegram') {
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.9169 3.125L18.7503 21.875L11.4586 14.54L15.8759 10.1605L9.82263 14.3469L12.4413 16.8306L8.85444 20.8333L7.81277 14.54L2.08447 11.4583L22.9169 3.125Z" fill="#B9A260"/>
              </svg>
            }
            @case ('whatsapp') {
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5002 1.30225C6.31574 1.30225 1.30226 6.31572 1.30226 12.5002C1.30226 14.4213 1.78667 16.2313 2.64044 17.8128L1.32881 22.7149C1.25669 22.9844 1.33379 23.272 1.53109 23.4693C1.72838 23.6665 2.01591 23.7436 2.28545 23.6715L7.18756 22.3599C8.76899 23.2137 10.5791 23.6981 12.5002 23.6981C18.6846 23.6981 23.6981 18.6846 23.6981 12.5002C23.6981 6.31572 18.6846 1.30225 12.5002 1.30225ZM7.29183 6.51058C7.08463 6.51058 6.88591 6.59289 6.7394 6.7394C6.59289 6.88592 6.51058 7.08463 6.51058 7.29183C6.51058 10.6578 8.13418 13.5733 9.78066 15.2198C11.4272 16.8663 14.3427 18.4897 17.7086 18.4897C17.9158 18.4897 18.1145 18.4074 18.2611 18.2609C18.4076 18.1144 18.4899 17.9157 18.4899 17.7085V14.6674C18.4899 14.2852 18.2134 13.9592 17.8365 13.8966L13.7898 13.2255L11.999 15.0494C11.5764 14.7485 11.2022 14.4317 10.8855 14.1149C10.5688 13.7982 10.2519 13.4241 9.95108 13.0015L11.7671 11.2183L11.1904 7.18134C11.1354 6.79646 10.8057 6.51058 10.417 6.51058L7.29183 6.51058Z" fill="#B9A260"/>
              </svg>
            }
          }
        </a>
      }
     
        
     
    </div>
  </div>
</div>
    <!-- Horizontal Divider -->
    <div class="w-full h-[1px] bg-white/20"></div>

    <!-- Bottom Section -->
    <div class="flex gap-[20px] items-center justify-center flex-wrap">
      <!-- Powered By -->
      <p class="text-[14px] text-white tracking-[0.14px]" style="font-family: 'IBM Plex Sans Arabic', sans-serif;">
        <span>{{ 'Footer.PoweredBy' | translate }} </span>
        <a href="https://cloud4rain.com/" target="_blank" class="underline cursor-pointer hover:text-[#FFBE11] transition-colors duration-200">
          Cloud4Rain
        </a>
      </p>

   

      <!-- Vertical Divider -->
      <div class="w-[1px] h-[20px] bg-white/20"></div>

      <!-- Copyright -->
      <p class="text-[14px] text-white tracking-[0.14px]" style="font-family: 'IBM Plex Sans Arabic', sans-serif;">
        {{ 'Footer.Copyright' | translate }}
      </p>
    </div>
     <div class="flex flex-col gap-[20px] items-center justify-center flex-wrap">
        <!-- Privacy Policy & Terms of Use -->
      <a
        [routerLink]="['/privacy-policy']"
        class="text-[14px] text-white tracking-[0.14px] underline cursor-pointer hover:text-[#FFBE11] transition-colors duration-200"
        style="font-family: 'IBM Plex Sans Arabic', sans-serif;"
        id="Footer_Link_PrivacyPolicy"
      >
        {{ 'privacy_terms.page_title' | translate }}
      </a>

    
      <!-- Delete Account Policy -->
      
        <a
          [routerLink]="['/delete-account-policy']"
          class="text-[14px] text-white tracking-[0.14px] underline cursor-pointer hover:text-[#FFBE11] transition-colors duration-200"
          style="font-family: 'IBM Plex Sans Arabic', sans-serif;"
          id="Footer_Link_DeleteAccountPolicy"
        >
          {{ 'Footer.deleteAccountPolicy' | translate }}
        </a>
    
     </div>
  </div>
</footer>
